/**
 * Бэкенд форм — воркер btq-api на том же домене: /api/fn/<функция> (TK-159, уход с Supabase).
 * Раньше формы ходили в Supabase edge-функции (tqevnxsnhpagutqvadsh.supabase.co/functions/v1/…);
 * код функций тот же, перенесён в btq.pt/tools/btq-api. Запрос идёт на свой домен, поэтому
 * без CORS и блокировщиков. Supabase выключен (TK-71), аварийный канал leadRescue снят.
 *
 * Локально (vite) /api/fn/* нет: задайте VITE_BTQ_API_BASE=https://btq-api.tolokhmatvei.workers.dev
 * в .env.local, чтобы формы работали из dev-сервера.
 */
const API_BASE = ((import.meta.env.VITE_BTQ_API_BASE as string | undefined) ?? "").replace(/\/$/, "");

export const fnUrl = (name: string): string => `${API_BASE}/api/fn/${name}`;

/** Та же форма ошибки, что у supabase-js: error.context — это Response функции. */
export class FnHttpError extends Error {
  context: Response;
  constructor(res: Response) {
    super(`Function returned ${res.status}`);
    this.name = "FunctionsHttpError";
    this.context = res;
  }
}

/** Замена supabase.functions.invoke(name, { body }): возвращает { data, error } в том же виде. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function invokeFn<T = any>(name: string, opts: { body?: unknown } = {}): Promise<{ data: T | null; error: (Error & { context?: Response }) | null }> {
  try {
    const res = await fetch(fnUrl(name), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(opts.body ?? {}),
    });
    if (!res.ok) return { data: null, error: new FnHttpError(res) };
    const isJson = (res.headers.get("Content-Type") || "").includes("json");
    return { data: (isJson ? await res.json() : await res.text()) as T, error: null };
  } catch (e) {
    return { data: null, error: e instanceof Error ? e : new Error(String(e)) };
  }
}
